import {InterCurrency} from "~/enums/siteEnum";
import {Message} from "element-ui";

export const state = () => ({
  info: {},
  ipInfo: {}, // ip 相关信息
  siteUserInfo: {}, // 用户绑定角色的信息
  siteLoginUserInfo: null, // 用户注册之后登录的账号
  isSiteBindUser: false, // 是否只通过 player_id登录系统（游客登录）
  token: '',
  loginShow: false,
  uuid: '',
  currencyRound: 2,
  isUpdateUuid: false, // 是否更新uuid 更新不显示loading刷新商品
  isAutoLogin: false,
  vipUserInfo: {
    growth: 0,
    points: 0
  }
})

export const mutations = {
  BIND_PLAYER_INFO(state, info){
    const uid =  info.uid || info.player_id || info.id
    state.siteLoginUserInfo = {
      ...info,
      ...state.siteLoginUserInfo,
      player: info,
      player_id: info.id
    }
    state.siteUserInfo = {
      ...info,
      uid: info.uid || info.player_id || info.id
    }
    state.uuid = uid
    state.isUpdateUuid = true
  },
  UPDATE_UUID(state, id){
    state.uuid = id
    state.isUpdateUuid = true
  },
  SET_SITE_BIND_USER(state, bol) {
    state.isSiteBindUser = bol
  },
  SET_SITE_LOGIN_USER(state, info) {
    state.siteLoginUserInfo = info
    if(info?.player){
      const id = info.uid || info.player_id
      state.siteUserInfo = {
        ...info.player,
        uid: info.uid || info.player_id,
      }
      state.uuid = id
    }
  },
  CLEAR_SITE_LOGIN_USER(state){
    state.siteLoginUserInfo = null
    state.siteUserInfo = null
    state.customerInfo = {}
  },
  CLEAR_SITE_LOGIN_USER_MODAL(state){
    state.siteLoginUserInfo = null
    state.siteUserInfo = null
    state.loginShow = false
  },
  SET_USER(state, info) {
    state.info = info
  },
  SET_SITEUSER(state, info) {
    state.siteUserInfo = info
    if (state.siteLoginUserInfo) {
      state.siteLoginUserInfo.player_id = info?.uid
    }

  },
  SET_VIP_USER_INFO(state, data) {
    state.vipUserInfo = data
  },
  SET_TOKEN(state,token){
    state.token = token
  },
  SET_LOGINSHOW(state, flag) {
    state.loginShow = flag
  },

  CLEAR_LOGIN_STATE(){
    state.user = null
    state.token = ''
  },
  SET_IPINFO (state, info) {
    state.currencyRound = InterCurrency.includes(info.currency) ? 0 : 2
    state.ipInfo = info;
  },
  SET_IS_AUTO_LOGIN(state, value) {
    state.isAutoLogin = value
  }
}

export const actions ={
   async LOGINOUT ({ commit }){
     await new Promise((resolve)=> {
       resolve(commit('CLEAR_LOGIN_STATE'))
     })
   },
  async getUserVipInfo(root) {
    const [err, res] = await this.$utils.to(this.$api.vip.getVipUserInfo())
    if (!err) {
      root.commit('SET_VIP_USER_INFO', res)
    } else {
      Message.error(err)
    }
  }
}
